import React from 'react';
import '../../styles/AdmissionProcess.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { FaWpforms, FaFileUpload, FaChalkboardTeacher, FaCheckCircle } from 'react-icons/fa';

const steps = [
  {
    icon: <FaWpforms />,
    title: 'Fill Application',
    description: 'Complete the online application form with accurate details.',
  },
  {
    icon: <FaFileUpload />,
    title: 'Upload Documents',
    description: 'Submit required documents like marksheets, ID proof, etc.',
  },
  {
    icon: <FaChalkboardTeacher />,
    title: 'Verification',
    description: 'College verifies the submitted application and documents.',
  },
  {
    icon: <FaCheckCircle />,
    title: 'Confirmation',
    description: 'Receive confirmation of admission and pay the fees.',
  },
];

const documents = [
  '10th & 12th Marksheet',
  'Transfer Certificate',
  'Aadhar Card Copy',
  'Caste Certificate (if applicable)',
  'Passport-size Photos',
];

const importantDates = [
  'Application Start Date: June 1, 2025',
  'Last Date to Apply: July 10, 2025',
  'Document Verification: July 15–20, 2025',
  'Admission Confirmation: July 25, 2025',
];

const AdmissionProcess = () => {
  return (
    <>
    < Navbar />
    <div className="admission-process-container fade-in" id="admission">
      <h2 className="admission-process-heading">Admission Process</h2>
      <p className="admission-process-subtext">
        Join B.Sc. with ease by following these simple steps.
      </p>

      <div className="admission-steps">
        {steps.map((step, index) => (
          <div className="step-card" key={index}>
            <div className="step-icon">{step.icon}</div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
          </div>
        ))}
      </div>

      <div className="required-documents">
        <h3>Required Documents</h3>
        <ul>
          {documents.map((doc, index) => (
            <li key={index}>{doc}</li>
          ))}
        </ul>
      </div>

      <div className="important-dates">
        <h3>Important Dates</h3>
        <ul>
          {importantDates.map((date, index) => (
            <li key={index}>{date}</li>
          ))}
        </ul>
      </div>

      <button className="apply-now-btn">Apply Now</button>
    </div>
    < Footer />
    </>
  );
};

export default AdmissionProcess;
